import { TpDocumento } from "./tpDocumento";

export class PacDocumentos {
    descricao: string[];
    tipoDocumento: TpDocumento[];
    extensao: string[];
    arquivo: File[];
  }
